export const GET_SUMMARY_DATA = "GET_SUMMARY_DATA";
export const GET_OPPORTUNITIES_DATA = "GET_OPPORTUNITIES_DATA";
export const GET_IMPLEMENTED_OPPORTUNITIES_DATA = "GET_IMPLEMENTED_OPPORTUNITIES_DATA";
export const GET_GROUPED_OPPORTUNITIES_DATA = "GET_GROUPED_OPPORTUNITIES_DATA";
export const GET_PRIORITY_OPPORTUNITIES_DATA = "GET_PRIORITY_OPPORTUNITIES_DATA";
export const GET_OPPORTUNITY_DETAIL = "GET_OPPORTUNITY_DETAIL";
export const GET_OPPORTUNITY_COMMENTS = "GET_OPPORTUNITY_COMMENTS";
export const GET_OPPORTUNITY_UPDATES = "GET_OPPORTUNITY_UPDATES";
export const GET_LABEL_SUGGESTIONS = "GET_LABEL_SUGGESTIONS";
export const GET_OPPORTUNITY_NAME_FILTERS = "GET_OPPORTUNITY_NAME_FILTERS";

// Curated priority opportunities are namespaced under this id prefix — the
// backend pairs it with `metadata.label = "priority"` to surface them in the
// Priority tab. Discover row clicks use it to route these rows (which have no
// concrete resource to redirect to) to the intermediary opportunity detail page.
export const PRIORITY_OPPORTUNITY_PREFIX = "priority/";

export const SORT_OPTIONS = [
  { label: "Money Savings(max)", value: "cost_savings_max" },
  { label: "Money Savings(min)", value: "cost_savings_min" },
  { label: "Time Savings(max)", value: "time_savings_max" },
  { label: "Time Savings(min)", value: "time_savings_min" },
];

export const PERIOD_OPTIONS = [
  { label: "Day", value: "day" },
  { label: "Week", value: "week" },
  { label: "Month", value: "month" },
];

export const EFFORT_OPTIONS = [
  { label: "Low", value: "low" },
  { label: "Medium", value: "medium" },
  { label: "High", value: "high" },
];

export const RESOURCE_TYPE_OPTIONS = [
  { label: "Query Hash", value: "query_hash" },
  { label: "Table", value: "table" },
  { label: "Warehouse", value: "warehouse" },
  { label: "User", value: "user" },
  { label: "Role", value: "role" },
  { label: "Dashboard", value: "dashboard" },
  { label: "dbt Project", value: "dbt_project" },
  { label: "dbt model", value: "dbt_model" },
];

export const RESOURCE_TYPE_OPTIONS_FREEMIUM = [
  { label: "dbt Project", value: "dbt_project" },
  { label: "dbt model", value: "dbt_model" },
];

// Mirrors the Databricks sidebar entity set. Snowflake's resource-type
// options resolve to enum values no Databricks opportunity carries, so
// Databricks tenants get their own list. `sql_warehouse` is deliberately
// distinct from Snowflake's `warehouse` so the backend can map it to the
// Databricks warehouse enum without colliding on the shared string name.
export const RESOURCE_TYPE_OPTIONS_DATABRICKS = [
  { label: "Cluster", value: "cluster" },
  { label: "SQL Warehouse", value: "sql_warehouse" },
  { label: "Job", value: "job" },
  { label: "Query", value: "query" },
  { label: "User", value: "user" },
  { label: "AI/ML", value: "aiml" },
];

// READ-side filter dropdown. "Implemented" is intentionally omitted —
// it lives on its own /discover tab backed by the implemented_opportunities
// table, so showing it as a filter would split the same view across
// two places.
export const STATUS_OPTIONS = [
  { label: "Active", value: "active" },
  { label: "Dismissed", value: "dismissed" },
];

// WRITE-side options for marking an opportunity's status. The user must
// still be able to flip an opportunity to IMPLEMENTED (which is what
// drives the row into the new table in the first place), so this list
// keeps all assignable statuses.
export const STATUS_ASSIGNMENT_OPTIONS = [
  { label: "Active", value: "active" },
  { label: "Implemented", value: "implemented" },
  { label: "Dismissed", value: "dismissed" },
];

export const ResourceTagColors = [
  { color: "#CCE2FF", textColor: "#247EFE" },
  { color: "#FFEAE4", textColor: "#FF7064" },
  { color: "#FFF4C3", textColor: "#893A00" },
];

export const EffortTagColors = {
  low: "#FAC515",
  medium: "#FF754C",
  high: "#EE140F",
  zero: "#079455",
};

export const StatusTagColors = {
  active: { color: "#E0EDFF", textColor: "#247EFE" },
  implemented: { color: "#D3FFEB", textColor: "#079455" },
  dismissed: { color: "#FEEEEE", textColor: "#EE140F" },
  closed: { color: "#FEEEEE", textColor: "#EE140F" },
};
